import { useState, useEffect, useCallback } from 'react'
import { FiCheck, FiInfo, FiHeart } from 'react-icons/fi'
import { TOAST_EVENT } from '../services/toast.service'
import '../assets/styles/toast.scss'

const ICONS = {
  success: <FiCheck />,
  info: <FiInfo />,
  like: <FiHeart />,
}

const Toaster = () => {
  const [toasts, setToasts] = useState([])

  const remove = useCallback((id) => {
    setToasts((list) => list.filter((t) => t.id !== id))
  }, [])

  useEffect(() => {
    const onToast = (e) => {
      const t = e.detail
      setToasts((list) => [...list, t])
      setTimeout(() => remove(t.id), 2600)
    }
    window.addEventListener(TOAST_EVENT, onToast)
    return () => window.removeEventListener(TOAST_EVENT, onToast)
  }, [remove])

  return (
    <div className='toaster'>
      {toasts.map((t) => (
        <div className={`toast toast-${t.type}`} key={t.id} onClick={() => remove(t.id)}>
          <span className='toast-icon'>{ICONS[t.type] || ICONS.info}</span>
          <span className='toast-msg'>{t.message}</span>
        </div>
      ))}
    </div>
  )
}

export default Toaster
